<div id="thebigimage">
    <div id="overlapthis">
        <h4>Doctors Lookup</h4>
        <p id="p1">Fill any one details below to</p>
        <p id="p2">Get all doctor details at a single click.</p>
        <div id="search">
            <div id="dropdown">
                <p-dropdown inputId="state" [options]="Type" [(ngModel)]="searchType" placeholder="Select Search Type"
                    optionLabel="name" [style]="{'width':'240px'}" required="true">
                </p-dropdown>
            </div>
            <div id="iputbox">
                <input type="text" pInputText placeholder="Enter Credentials" required="true" #mrn />
            </div>
            <div id="btn">
                <button pButton type="button" label="Search" icon="pi pi-search"
                    (click)="getInput(searchType.value,mrn.value)">
                </button>
            </div>
            <i *ngIf="loading" class="pi pi-spin pi-spinner" style="font-size: 2rem;margin-left: 160px;"></i>
            <p *ngIf="error!= null" style="color: red; text-align: center;font-weight: bold;">{{error}}</p>
        </div>

    </div>
</div>
